<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md4 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              label="岗位监测公司"
              v-model="insertData.organizationName"
              removable
              :messages="message"
              :error="!!error.organizationNameErrors.length"
              :error-messages="error.organizationNameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="状态"
              v-model="insertData.status"
              :options="statusOptions"
              :messages="message"
              :error="!!error.statusErrors.length"
              :error-messages="error.statusErrors"
            />
          </div>
          <div class='flex md4 sm6 xs12' v-show="showCreatedAt">
            <va-input
              v-model='insertData.createTime'
              label='创建时间'
              disabled
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import careerMonitorApi from '../../api/careerMonitor'
import { copyObject, formatTime } from '@/utils/common'

export default {
  data () {
    return {
      insertData: {
        id: null,
        organizationName: '',
        status: '未处理',
        createTime: '',
      },
      placeholders: {
      },
      message: ['Required field'],
      careerMonitorTags: [],
      courseTags: [],
      organizations: [],
      error: {
        organizationNameErrors: [],
        statusErrors: [],
      },
      showId: false,
      showCreatedAt: false,
      title: '新增岗位监测',
      statusOptions: ['未处理', '成功', '失败'],
      submitButtonStatus: true,
    }
  },
  created () {
    this.getCareerMonitor()
  },
  computed: {
    formReady () {
      return !this.error.organizationNameErrors.length &&
          !this.error.statusErrors.length
    },
  },
  methods: {
    getCareerMonitor () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.showCreatedAt = true
        this.title = '编辑岗位监测'
        // 通过id获取详情
        careerMonitorApi.getCareerMonitor(params.id).then(response => {
          copyObject(response.careerMonitor, this.insertData)
          this.insertData.createTime = formatTime(this.insertData.createTime)
          // eslint-disable-next-line no-prototype-builtins
          if (response.careerMonitor.hasOwnProperty('status')) {
            if (response.careerMonitor.status === 0) {
              this.insertData.status = '未处理'
            } else if (response.careerMonitor.status === 1) {
              this.insertData.status = '成功'
            } else {
              this.insertData.status = '失败'
            }
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        uid: this.insertData.uid,
        organizationName: this.insertData.organizationName,
      }
      if (this.insertData.status === null || this.insertData.status === '未处理') {
        data.status = 0
      } else if (this.insertData.status === '成功') {
        data.status = 1
      } else {
        data.status = 2
      }
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        careerMonitorApi.updateCareerMonitor(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('更新岗位监测成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listCareerMonitor' })
          }
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
          this.changeButtonStatus(true)
        })
      } else {
        careerMonitorApi.saveCareerMonitor(data).then(response => {
          if (response.success === true) {
            this.showToast('保存岗位监测成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listCareerMonitor' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.organizationNameErrors = this.insertData.organizationName ? [] : ['organizationName is required']
      this.error.statusErrors = this.insertData.status ? [] : ['status is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
